import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { seperateSlotsByTimeOfDay } from 'Common/components/TimeSlotSelect/fn';

dayjs.extend(tz);
dayjs.extend(utc);

type TimeSlotSelectProps = {
  slots: number[];
  onSelect: (v: number) => void;
  value?: number | null;
  empty?: React.ReactNode;
  disabled?: boolean;
}
type timeOfDayLabel = { label: string, timeSlots: number[] };

const TimeSlotSelect: React.FC<TimeSlotSelectProps> = ({
  slots,
  onSelect,
  value,
  empty,
  disabled = false,
}) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const {
    morningSlots,
    afternoonSlots,
    eveningSlots,
  } = useMemo(
    () => seperateSlotsByTimeOfDay(slots, timezone),
    [slots, timezone],
  );

  const slotsByTimeOfDay: timeOfDayLabel[] = [
    {
      label: 'Morning', timeSlots: morningSlots,
    },
    {
      label: 'Afternoon', timeSlots: afternoonSlots,
    },
    {
      label: 'Evening', timeSlots: eveningSlots,
    }
  ];

  return (
    <div
      className="flex flex-col gap-6 md:mb-4"
    >
      {slots.length ? slotsByTimeOfDay.map(group => {
        return group.timeSlots.length > 0 && (
          <div key={group.label} className="flex flex-col gap-2">
            <span className="uppercase text-xs font-bold">
              {group.label}
            </span>
            <div className="flex flex-wrap gap-4">
              {group.timeSlots.map((slot, i) => {
                const formattedTime = dayjs
                  .unix(slot)
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format('h:mm A');

                return (
                  <button
                    key={i}
                    type="button"
                    onClick={(): void => {
                      onSelect && onSelect(slot);
                    }}
                    className={`rounded border-solid border-gray-200 border p-4 font-bold ${slot === value ? 'bg-primary text-white' : 'bg-white text-black'} ${disabled ? 'pointer-events-none opacity-60' : ''}`}
                  >
                    {formattedTime}
                  </button>
                );
              }
              )}
            </div>
          </div>
        );
      }) : empty}
    </div>
  );
};

export default TimeSlotSelect;

